import React, { useState, useEffect, useCallback } from 'react';
import { CalendarRange, Search } from 'lucide-react';
import HeroBackground from './HeroBackground';
import TourSelectionModal from './TourSelectionModal';

const Hero = () => {
  const [imageScale, setImageScale] = useState(1);
  const [isMobile, setIsMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isButtonsVisible, setIsButtonsVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const scrollToAdventures = () => {
    const adventuresSection = document.querySelector('#adventures');
    if (adventuresSection) {
      adventuresSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    const handleScroll = () => {
      const maxScroll = window.innerHeight;
      const scale = Math.min(1.15, 1 + (window.scrollY / maxScroll) * 0.15);
      setImageScale(scale);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', checkMobile);
    
    checkMobile();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', checkMobile);
    };
  }, [isMobile]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
      setIsButtonsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative h-screen overflow-hidden">
      <meta name="theme-color" content="#000000" />
      <HeroBackground imageScale={imageScale} isMobile={isMobile} />

      {/* Center Content */}
      <div className="absolute inset-x-0 bottom-[calc(100vh_-_88vh)] lg:bottom-12 flex flex-col container max-w-7xl mx-auto px-4 md:px-8 lg:px-16 items-end text-end lg:text-start lg:items-start">
        <h2 className={`font-barrio text-4xl md:text-6xl tracking-tighter leading-[1.1] [text-shadow:_0_4px_8px_rgba(0,0,0,0.4),_0_-4px_8px_rgba(0,0,0,0.4)] transition-all duration-1000 ${
          isVisible 
            ? 'translate-x-0 opacity-100' 
            : isMobile
              ? 'translate-x-full opacity-0'
              : '-translate-x-full opacity-0'
        }`}>
          EXPLORE AND ENJOY
          <br />
          THE COSTA RICAN WONDERS
        </h2>
        
        <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto max-w-xs sm:max-w-none mt-4 sm:mt-2 sm:justify-end lg:justify-start">
          <button 
            onClick={scrollToAdventures}
            className={`flex items-center justify-between px-4 py-3 sm:py-2 bg-white/20 backdrop-blur-sm text-white rounded-[1rem] hover:bg-white/30 transition-all duration-1000 hover:scale-105 w-full sm:w-auto ${
              isButtonsVisible 
                ? 'translate-x-0 opacity-100' 
                : isMobile
                  ? 'translate-x-full opacity-0'
                  : '-translate-x-full opacity-0'
            }`}
          >
            Explore All Our Adventures
            <span className="bg-white/20 p-2 rounded-lg ml-2 sm:ml-6">
              <Search className="w-5 h-5" />
            </span>
          </button>
          <button 
            onClick={() => setIsModalOpen(true)}
            className={`flex items-center justify-between px-4 py-3 sm:py-2 bg-[#953B0E] text-white rounded-[1rem] hover:bg-[#ff6a0d] transition-all duration-1000 hover:scale-105 w-full sm:w-auto border-2 border-[#E85C0D] ${
              isButtonsVisible 
                ? 'translate-x-0 opacity-100' 
                : isMobile
                  ? '-translate-x-full opacity-0'
                  : 'translate-x-full opacity-0'
            }`}
          >
            Book A Tour
            <span className="bg-white/20 p-2 rounded-lg ml-2 sm:ml-6">
              <CalendarRange className="w-5 h-5" />
            </span>
          </button>
        </div>
      </div>

      <TourSelectionModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default Hero;